import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';

// Components
import EditGroupContainer from '../group-modals/edit-group-modal';
import GroupModal from '../group-modals/group-modal';

// Context
import CourseInformationContext from '../context/course-information-context';

// Helpers
import { resetGroupSectionScroll } from '../../../helpers/utils';
import { DEFAULT_GROUP_MODAL_ID } from '../../../helpers/enums';

function NewGroupItem(props) {
    // Props
    const {
        showModal,
        currentGroupId,
        groupModalVisibility,
        groupModalId,
        productId,
        newGroupHandler,
        showNewCourses,
        newCoursesAvailabilityCriteria
    } = props;

    // Context Variables
    const {
        // Select Options
        // - Country
        setCountryHandler,
        countrySelectValue,
        countrySelectOptions,
        // - Year
        setYearHandler,
        yearSelectValue,
        yearSelectOptions,
        // - Course
        setCourseHandler,
        courseSelectValue,
        courseSelectOptions,
        // - UPF Course
        setUPFCourseHandler,
        upfCourseSelectValue,
        upfCourseSelectOptions,
        // New Course
        setNewCourseHandler,
        newCourseSelectValue,
        newCourseSelectOptions
    } = useContext(CourseInformationContext);

    const closeHandler = () => {
        resetGroupSectionScroll();
        setCountryHandler('');
        setYearHandler('');
        showModal({ modalId: DEFAULT_GROUP_MODAL_ID, isClosing: true });
    };
    const saveHandler = async ({ name }) => {
        const newGroupResponse = await newGroupHandler({ name });

        if (newGroupResponse.valid === true) {
            closeHandler();
        }
        return true;
    };
    const localSetCountryHandler = (e) => {
        const value = e.target.value;
        setCountryHandler(value);
    };
    const localSetYearHandler = (e) => {
        const value = e.target.value;
        setYearHandler(value);
    };
    const localSetCourseHandler = (e) => {
        const value = e.target.value;
        setCourseHandler(value);
    };
    const localSetUPFCourseHandler = (e) => {
        const value = e.target.value;
        setUPFCourseHandler(value);
    };
    const localSetNewCourseHandler = (e) => {
        const value = e.target.value;
        setNewCourseHandler(value);
    };

    // Course Specific props to handle the data/display
    const courseSpecificProps = {
        // Countries
        setCountryHandler: localSetCountryHandler,
        countrySelectValue,
        countrySelectOptions,
        // Years/Grades
        setYearHandler: localSetYearHandler,
        yearSelectValue,
        yearSelectOptions,
        // Courses
        setCourseHandler: localSetCourseHandler,
        courseSelectValue,
        courseSelectOptions,
        // New Courses i.e. conquest courses
        setNewCourseHandler: localSetNewCourseHandler,
        newCourseSelectValue,
        newCourseSelectOptions,
        // - UPF Course
        setUPFCourseHandler: localSetUPFCourseHandler,
        upfCourseSelectValue,
        upfCourseSelectOptions
    };

    return (
        <div style={{ display: 'flex' }}>
            {
                currentGroupId === groupModalId && groupModalVisibility ? (
                    <EditGroupContainer
                        title={<Trans id="Group Modal - new - title" />}
                        closeHandler={closeHandler}
                        parentClasses="modal--edit-groups">
                        <GroupModal
                            inputId={`new-group-input${currentGroupId}`}
                            initialName=""
                            currentId={currentGroupId}
                            productId={productId}
                            saveHandler={saveHandler}
                            closeHandler={closeHandler}
                            hasEdited={false} // default value
                            showNewCourses={showNewCourses}
                            newCoursesAvailabilityCriteria={newCoursesAvailabilityCriteria}
                            isNewGroup
                            {...courseSpecificProps}
                        />
                    </EditGroupContainer>
                ) : ''
            }
        </div>
    );
}

NewGroupItem.propTypes = {
    showModal: PropTypes.func,
    newGroupHandler: PropTypes.func,
    currentGroupId: PropTypes.number,
    groupModalVisibility: PropTypes.bool,
    groupModalId: PropTypes.number,
    productId: PropTypes.number,
    showNewCourses: PropTypes.bool,
    newCoursesAvailabilityCriteria: PropTypes.object
};

export default NewGroupItem;



// WEBPACK FOOTER //
// ./components/groups/item/new-group-item.js